// extracted by mini-css-extract-plugin
export default {"text":"LogoutButton_text__3OhqK"};